import { useRoutes } from "react-router-dom";
import PaymentDetails from "./pages/payment-details/payment-details";
import PaymentSuccess from "./pages/payment-success/payment-success";
import PaymentFailed from "./pages/payment-failed/payment-failed";
import PaymentAlreadyPaid from "./pages/payment-already-paid/payment-already-paid";
import PaymentRefundIssued from "./pages/payment-refund-issued/payment-refund-issued";
import PaymentExpired from "./pages/payment-expired/payment-expired";
import PaymentCancelled from "./pages/payment-cancelled/payment-cancelled";
import PaymentValidation from "./pages/payment-validation/payment-validation";
import AppMaintenance from "./pages/app-maintenance/app-maintenance";
import PayNowFromWebsite from "./pages/pay-now-from-website/pay-now-from-website";
import PaymentInvalid from "./pages/payment-invalid/payment-invalid";
import NTTDataForm from "./pages/payment-details/NTTData-form";
import PartialPayment from "./pages/partial-payments";

const AppRouter = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <PaymentDetails />,
    },
    {
      path: "/:token",
      element: <PaymentDetails />,
    },{
      path: "/ndpayments",
      element: <NTTDataForm/>,
    },
    {
      path: "/payment-success",
      element: <PaymentSuccess/>,
    },
    {
      path: "/payment-failed",
      element: <PaymentFailed/>,
    },
    {
      path: "/status",
      element: <PaymentValidation/>,
    },
    {
      path: "/status/:beneId/:traceId",
      element: <PaymentValidation/>,
    },
    {
      path: "/payment-cancelled",
      element: <PaymentCancelled/>,
    },
    {
      path: "/payment-expired",
      element: <PaymentExpired/>,
    },
    {
      path: "/payment-already-paid",
      element: <PaymentAlreadyPaid/>,
    },
    {
      path: "/refund-issued",
      element: <PaymentRefundIssued/>,
    },
    {
      path: "/maintenance",
      element: <AppMaintenance/>,
    },
    {
      path: "/paynowfromwebsite",
      element: <PayNowFromWebsite/>,
    },
    {
      path: "/invalid-payment",
      element: <PaymentInvalid />,
    },
    {
      path: "/partial-payment",
      element: <PartialPayment />,
    },
  ]);
  return routes;
};

export default AppRouter;
